import request from '@/service/request'

// 获取用户权限目录选择树
export function getUserScopeTreeService(data) {
    return request.post('/v3/ProjectUserRelation/ByProject/GetUserScopeSelectTree', data);
}

// 更新项目内用户权限
export function updateUserScopeService(data) {
    return request.post('/v3/ProjectUserRelation/ByProject/UpdateUserScope', data);
}
